import { lazyLoad } from 'utils/loadable';

export const Checklist = lazyLoad(() => import('./index.js'));
